import { useEffect, useState } from 'react';
import { getCampaignsConfig } from '../services/api';
import { useWorkspace } from '../context/WorkspaceContext';

const EMPTY = { visible: false, allowed: false, reason: null, rollbackDays: null, maxLatenessMinutes: null };

export function useCampaignsConfig() {
  const { selectedWorkspace, loading: wsLoading } = useWorkspace();
  const workspaceId = selectedWorkspace?.id || null;
  const [state, setState] = useState({ ...EMPTY, loading: true });

  useEffect(() => {
    if (!workspaceId) {
      // Still resolving workspaces: stay loading. Finished with none: resolve hidden so pages redirect.
      setState(wsLoading ? (s) => ({ ...s, loading: true }) : { ...EMPTY, loading: false });
      return undefined;
    }
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    getCampaignsConfig()
      .then((c) => { if (!cancelled) setState({ ...EMPTY, ...c, loading: false }); })
      .catch(() => { if (!cancelled) setState({ ...EMPTY, loading: false }); });
    return () => { cancelled = true; };
  }, [workspaceId, wsLoading, selectedWorkspace?.plan, selectedWorkspace?.features?.campaigns]);

  return state;
}

export default useCampaignsConfig;
